import React from "react";
import { BarChart, Bar, Tooltip, ResponsiveContainer, CartesianGrid, XAxis, YAxis } from "recharts";

export const BarCharts = (props) => {
  return (
    <ResponsiveContainer height={props.height ? props.height : 450} width="100%">
      <BarChart data={props?.data} barSize={50}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="businessname" />
        <YAxis />
        <Tooltip cursor={{ fill: "transparent" }} />

        <Bar dataKey="numberofoffers" stackId="a" fill={props.color} label={{ position: "center" }} />
      </BarChart>
    </ResponsiveContainer>
  );
};
